import { provideRtkDesignSystem } from '@cloudflare/realtimekit-ui';
import { collectElementsDeepShadow } from './applyScopedControlbarHoverBackground';
import { normalizeThemeHex, pickAccessibleForeground } from './wcagContrast';

/** Matches kit default / App.css `--rtk-colors-danger`. */
export const RTK_DEFAULT_DANGER_HEX = '#ff2d2d';

const DANGER_MIN_RATIO = 3;

/**
 * Scope `danger` to mic/camera toggle hosts so disabled (off) state stays visible on warm button fills.
 *
 * @param {HTMLElement | null} meetingHostEl outer `<rtk-meeting>`
 * @param {string | null | undefined} buttonBackgroundHex — theme `buttonBackground`
 */
export function applyAccessibleToggleDanger(meetingHostEl, buttonBackgroundHex) {
  if (!meetingHostEl?.shadowRoot || typeof window === 'undefined') return;

  const bg = normalizeThemeHex(buttonBackgroundHex);
  if (!bg) return;

  const dangerHex =
    pickAccessibleForeground(bg, RTK_DEFAULT_DANGER_HEX, { minRatio: DANGER_MIN_RATIO }) ??
    RTK_DEFAULT_DANGER_HEX;

  const sr = meetingHostEl.shadowRoot;
  const micToggles = collectElementsDeepShadow(sr, 'rtk-mic-toggle');
  const cameraToggles = collectElementsDeepShadow(sr, 'rtk-camera-toggle');
  for (const el of [...micToggles, ...cameraToggles]) {
    provideRtkDesignSystem(el, { colors: { danger: dangerHex } });
  }
}
